import { HookOutOfContextError } from "@jugl-web/utils";
import { useContext } from "react";
import { TicketsViewContext } from "./TicketsViewContext";

export const useTicketsViewContext = () => {
  const context = useContext(TicketsViewContext);

  if (!context) {
    throw new HookOutOfContextError(
      "useTicketsViewContext",
      "TicketsViewContext"
    );
  }

  return context;
};
